export const APP_LOCALES = ['en', 'ru'] as const

export type AppLocale = (typeof APP_LOCALES)[number]

export const DEFAULT_LOCALE: AppLocale = 'en'
export const FALLBACK_LOCALE: AppLocale = DEFAULT_LOCALE

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && APP_LOCALES.some((locale) => locale === value)
}

export function matchAppLocale(languageTag: string): AppLocale | null {
  const language = languageTag.trim().toLowerCase().split(/[-_]/u)[0]
  return isAppLocale(language) ? language : null
}

export function detectBrowserLocale(languages: ReadonlyArray<string>): AppLocale {
  for (const language of languages) {
    const locale = matchAppLocale(language)
    if (locale !== null) return locale
  }
  return DEFAULT_LOCALE
}
